import clsx from 'clsx';
import * as React from 'react';
import {
    ColorSwatchPicker as RACColorSwatchPicker,
    ColorSwatchPickerItem as RACColorSwatchPickerItem,
    type ColorSwatchPickerItemProps as RACColorSwatchPickerItemProps,
    type ColorSwatchPickerProps as RACColorSwatchPickerProps,
} from 'react-aria-components';

export type ColorSwatchPickerProps = RACColorSwatchPickerProps;

/**
 * A ColorSwatchPicker displays a list of color swatches and allows a user to select one of them.
 */
export const ColorSwatchPicker = React.forwardRef(function ColorSwatchPicker(
    props: ColorSwatchPickerProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <RACColorSwatchPicker
            ref={ref}
            {...props}
            className={clsx('flex flex-wrap gap-2', props.className)}
        />
    );
});

export type ColorSwatchPickerItemProps = RACColorSwatchPickerItemProps;

/**
 * A ColorSwatchPickerItem displays a color swatch that can be selected by the user.
 */
export const ColorSwatchPickerItem = React.forwardRef(function ColorSwatchPickerItem(
    props: ColorSwatchPickerItemProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <RACColorSwatchPickerItem
            ref={ref}
            {...props}
            className={clsx(
                'relative w-fit rounded outline-none forced-color-adjust-none',
                'data-[focus-visible]:shadow-focus-ring',
                'data-[selected]:after:absolute data-[selected]:after:inset-0 data-[selected]:after:content-[""]',
                'data-[selected]:after:border data-[selected]:after:border-black data-[selected]:after:border-solid',
                'data-[selected]:after:-outline-offset-2 data-[selected]:after:rounded data-[selected]:after:outline data-[selected]:after:outline-1 data-[selected]:after:outline-white',
                props.className
            )}
        />
    );
});
